<template>
  <div class="abstract-card" v-if="formList">
    <div class="header">
      <div class="title">{{$t('components.abstract.tabs.abstractPackages.abstractPackages')}}</div>
      <span>{{$t('components.abstract.tabs.abstractPackages.abstractPackagesMsg')}}</span>
    </div>
    <template v-if="formList.length > 0 && packetIds">
      <div class="packet-content mt-2" v-for="item in formList" :key="item.id">
        <div class="packet-head">{{ item.title }}</div>
        <div class="list" v-for="packet in item.packets" :key="packet.packetId">
          <div class="list-item d-flex justify-content-between">
            <div class="list-item-title">{{ packet.title }} </div>
            <el-switch :value="packetIds.some((x) => x == packet.packetId)" @change="packetToggle(packet.packetId)"></el-switch>
          </div>
        </div>
      </div>
      <div class="bottom mt-3 d-flex justify-content-end">
        <el-button type="primary" size="mini" round :loading="loading" @click="saveAbstractPackets">{{$t('components.abstract.tabs.abstractPackages.save')}}</el-button>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {
      packetIds: [],
      loading: false,
      timeout: null,
    };
  },
  async created() {
    this.packetIds = this.data;
    await this.$store.dispatch('getRegisterForm');
  },
  methods: {
    packetToggle(id) {
      if (this.packetIds.some((x) => x == id)) {
        var cIndex = this.packetIds.findIndex((x) => x == id);
        this.packetIds = this.packetIds.splice(cIndex, 1);
      } else {
        this.packetIds.push(id);
      }
    },
    async saveAbstractPackets() {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.loading = true;
      await this.$store.dispatch('abstractUpdatePackages', { packetIds: this.packetIds });

      this.timeout = setTimeout(async () => {
        this.loading = false;
      }, 500);
    },
  },
  computed: {
    formList() {
      return this.$store.getters.getRegisterFormList;
    },
  },
  watch: {
    data() {
      if (this.data != undefined && this.data != null) {
        this.packetIds = this.data;
      }
    },
  },
};
</script>

<style lang="less">
.abstract-card {
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.5);
  padding: 1rem;
  & > .header {
    color: black;
    & > .title {
      display: flex;
      font-weight: bold;
    }
    span {
      font-weight: 400;
    }
  }
}
.packet-content {
  .packet-head {
    padding: 0.4rem;
    background-color: #f1f1f1;
    border-radius: 8px;
    margin-bottom: 0.4rem;
    font-weight: bold;
  }
  .list {
    padding: 0.4rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    .list-item {
      align-items: center;
      .list-item-title {
        color: #03658c;
        text-decoration: underline;
        font-weight: bold;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/abstract/tabs/AbstractPackages.vue